import { refreshAccessToken, setTokens } from './tokenHandler';

const userAdminBaseRoute = 'puzzeladmin/useradmin'
const formConfigBaseRoute = 'puzzeladmin/formconfiguration'
const tmwBaseRoute = 'puzzeladmin/tmw'


/*
  CRUD USER
*/

export const getUser = async (key, db) => {
  await refreshAccessToken();
  return fetch(`/${userAdminBaseRoute}/${key}/${db}`,  
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
          'puzzelToken': `${localStorage.getItem('puzzelToken')}`
        }
      }
    ).then((response) => {
      if(response.ok){
        refreshAccessToken();
        return response.json()
      }else
       throw new Error(`HTTPStatusCode: ${response.status}. Message: ${response.statusText}`)
    })
}


export const getUsers = async (db) => {
 await refreshAccessToken();
 return fetch(`/${userAdminBaseRoute}/${db}`,  
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
          'puzzelToken': `${localStorage.getItem('puzzelToken')}`
        }
      }
    ).then((response) => {
      if(response.ok){
        return response.json()
      }else
        throw new Error(`HTTPStatusCode: ${response.status}. Message: ${response.statusText}`)
    })
  }


export const saveUser = async (user, db) => {
  await refreshAccessToken();
  return fetch(`/${userAdminBaseRoute}/${user.key}/${db}`,  
  {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
      'puzzelToken': `${localStorage.getItem('puzzelToken')}`
    },
    body: JSON.stringify(user)
  }
  ).then((response) => {
    if(response.ok){
      return response.json()
    }else
     throw new Error(`HTTPStatusCode: ${response.status}. Message: ${response.statusText}`)
  })
}



export const deleteUser = async (key, db) => {
  await refreshAccessToken();
  return fetch(`/${userAdminBaseRoute}/${key}/${db}`,  
  {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
      'puzzelToken': `${localStorage.getItem('puzzelToken')}`
    }
  }
  ).then((response) => {
    if(response.ok){
      return response.json()
    }else
     throw new Error(`HTTPStatusCode: ${response.status}. Message: ${response.statusText}`)
  })
}


export const createUser = async (user, db) => {
  await refreshAccessToken();
  return fetch(`/${userAdminBaseRoute}/${db}`,  
  {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
      'puzzelToken': `${localStorage.getItem('puzzelToken')}`
    },
    body: JSON.stringify(user)
  }
  ).then((response) => {
    if(response.ok){
      return response.json()
    }else
     throw new Error(`HTTPStatusCode: ${response.status}. Message: ${response.statusText}`)
  })
}


/*
  FORM CONFIGURATION
*/

export const getFormConfiguration = async ({app}) => {
  await refreshAccessToken();
  return fetch(`/${formConfigBaseRoute}/${localStorage.getItem('puzzelToken')}/${app}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
          'puzzelToken': `${localStorage.getItem('puzzelToken')}`
        }
      }
    ).then((response) => {
      if(response.ok){
        return response.json()
      }else
      throw new Error(`HTTPStatusCode: ${response.status}. Message: ${response.statusText}`)
    })
}




/*
   TMW
*/
export const updateUserInExchange = async ({user}) => {
  await refreshAccessToken();
  return fetch(`/${tmwBaseRoute}/user/exchange/update`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
          'puzzelToken': `${localStorage.getItem('puzzelToken')}`
        },
        body: JSON.stringify({user: user})
      }
    ).then((response) => {
      if(response.ok){
        return response.json()
      }else
      throw new Error(`HTTPStatusCode: ${response.status}. Message: ${response.statusText}`)
    })
}